<template>
  <div
    class="relative overflow-hidden bg-white dark:bg-gray-800 rounded-2xl"
  >
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
